<ul *ngIf="pager.pages && pager.pages.length" class="pagination">
  <li [ngClass]="{disabled:pager.currentPage === 1}" class="page-item first-item">
    <button (click)="setPage(1)" class="page-link">
      <img alt="" *ngIf="pager.currentPage === 1" src="assets/images/pagination-first.svg"
        class="arrow-icon first-arrow-icon" />
      <img alt="" *ngIf="pager.currentPage !== 1" src="assets/images/pagination-first-active.svg"
        class="arrow-icon first-arrow-icon" aria-label="First" />
      {{ !showArrow" ? 'First' : '' }}
    </button>
  </li>
  <li [ngClass]="{disabled:pager.currentPage === 1}" class="page-item previous-item" *ngIf="!showArrow">
    <button (click)="setPage(pager.currentPage - 1)" class="page-link" aria-label="Previous">Previous</button>
  </li>
  <li [ngClass]="{disabled:pager.currentPage === 1}" class="page-item previous-item" *ngIf="showArrow">
    <button role="button" (click)="setPage(pager.currentPage - 1)" class="page-link">
      <img alt="" src="assets/images/pagination-first.svg" class="arrow-icon first-arrow-icon" />
    </button>
  </li>
  <ng-container *ngIf="pager.totalPages < endPageMultiple">
    <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}" class="page-item number-item">
      <button role="button" (click)="setPage(page)" class="page-link" aria-label="page">{{page}}</button>
    </li>
  </ng-container>
  <ng-container *ngIf="pager.totalPages >= endPageMultiple">
    <li *ngIf="pager.currentPage > activePageLength" class="page-item number-item">
      <button role="button" (click)="setPage(1)" class="page-link">1</button>
    </li>
    <li *ngIf="pager.currentPage > activePageLength" class="page-item number-item">
      <button role="button" (click)="prevBlock(activePages)" class="page-link">...</button>
    </li>
    <li *ngFor="let page of activePages" [ngClass]="{active:pager.currentPage === page}" class="page-item number-item">
      <button role="button" (click)="setPage(page)" class="page-link">{{page}}</button>
    </li>
    <li *ngIf="activePages[activePageLength - 1] < pager.totalPages" class="page-item number-item">
      <button role="button" (click)="nextBlock(activePages)" class="page-link">...</button>
    </li>
    <li *ngIf="activePages[activePageLength - 1] < pager.totalPages" class="page-item number-item">
      <button role="button" (click)="setPage(pager.totalPages)" class="page-link" aria-label="pager.totalPages">
        {{pager.totalPages}}
      </button>
    </li>
  </ng-container>
  <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}" class="page-item next-item" *ngIf="!showArrow">
    <button role="button" (click)="setPage(pager.currentPage + 1)" class="page-link" aria-label="Next">
      Next
    </button>
  </li>
  <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}" class="page-item next-item" *ngIf="showArrow">
    <button role="button" (click)="setPage(pager.currentPage + 1)" class="page-link">
      <img alt="" src="assets/images/pagination-last.svg" class="arrow-icon last-arrow-icon" />
    </button>
  </li>
  <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}" class="page-item last-item">
    <button role="button" (click)="setPage(pager.totalPages)" class="page-link" aria-label="Last">
      {{ !showArrow ? 'Last' : '' }}
      <img alt="" *ngIf="pager.currentPage === pager.totalPages" src="assets/images/pagination-last.svg"
        class="arrow-icon last-arrow-icon" />
      <img alt="" *ngIf="pager.currentPage !== pager.totalPages" src="assets/images/pagination-last-active.svg"
        class="arrow-icon last-arrow-icon" />
    </button>
  </li>
</ul>